import { Figure } from "components/Figure";
import styles from "./Embed.module.css";

export const IframeWrapper = ({ primary }) => {
  const { caption, embed } = primary;

  return (
    <Figure caption={caption}>
      <div className={styles.iframeContainer}>
        <iframe src={embed?.url} />
      </div>
    </Figure>
  );
};
